
import LolePicture from '~/components/picture/lole-picture'
import LoleH3 from '~/components/text/lole-h3'
import generateHeader from '~/helpers/header'

export default {
  components: {
    LolePicture,
    LoleH3,
  },
  async asyncData({ error, app: { $storyblok, $sentryException, $gtm } }) {
    try {
      $gtm.push({
        ecommerce: undefined,
        product: undefined,
        search: undefined,
      })
      $gtm.push({ 'page.type': 'static' })
    } catch (e) {
      $sentryException(e, {
        source: 'GTM page about us',
        level: 'warning',
        extra: 'GTM page about us failed',
      })
    }
    let wording
    try {
      const pageInfo = await $storyblok.getStory(`/static_pages/about-us`)
      wording = pageInfo.story.content
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok /static_pages/about-us failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok /static_pages/about-us failed',
      })
    }
    return { wording }
  },
  data: () => ({
    wording: null,
  }),
  head() {
    if (!this.wording.SEO) return {}

    this.wording.SEO.og_image = this.wording.SEO.og_image
      ? this.wording.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE

    return generateHeader({
      ...this.wording.SEO,
      path: this.$route.path,
    })
  },
}
